'use client';
import type { ReactElement } from 'react';
import { getFontFamily } from '@/theme/typography';
import { dataEl, type DataElScope } from '@/utils/dataEl';
const PREVIEW_NODE_GAP = 4;
const PREVIEW_CONNECTOR_WIDTH = 1.5;
const PREVIEW_CONNECTOR_HEIGHT = 12;
const START_NODE_RADIUS = 999;
const MIDDLE_NODE_RADIUS = 4;
const END_NODE_RADIUS = 6;
const START_NODE_BACKGROUND = 'rgba(0,55,29,0.7)';
const DEFAULT_NODE_BACKGROUND = 'rgba(0,0,0,0.55)';
const START_NODE_RING_COLOR = '#66FEC1';
const DEFAULT_NODE_RING_COLOR = 'rgba(102,254,193,0.55)';
const START_NODE_TEXT_COLOR = '#66FEC1';
const DEFAULT_NODE_TEXT_COLOR = 'rgba(255,255,255,0.85)';
interface FlowchartCompactPreviewNodeProps {
    dataElScope: DataElScope;
    hasConnector: boolean;
    isEnd: boolean;
    isStart: boolean;
    label: string;
}
function getPreviewNodeRadius(input: {
    isEnd: boolean;
    isStart: boolean;
}): number {
    if (input.isStart) {
        return START_NODE_RADIUS;
    }
    return input.isEnd ? END_NODE_RADIUS : MIDDLE_NODE_RADIUS;
}
function getPreviewNodeBackgroundColor(isStart: boolean): string {
    if (isStart) {
        return START_NODE_BACKGROUND;
    }
    return DEFAULT_NODE_BACKGROUND;
}
function getPreviewNodeBoxShadow(isStart: boolean): string {
    const ringColor = getPreviewNodeRingColor(isStart);
    return `inset 0 0 0 1px ${ringColor}`;
}
function getPreviewNodeRingColor(isStart: boolean): string {
    if (isStart) {
        return START_NODE_RING_COLOR;
    }
    return DEFAULT_NODE_RING_COLOR;
}
function getPreviewNodeTextColor(isStart: boolean): string {
    if (isStart) {
        return START_NODE_TEXT_COLOR;
    }
    return DEFAULT_NODE_TEXT_COLOR;
}
export function FlowchartCompactPreviewNode({ dataElScope, hasConnector, isEnd, isStart, label, }: FlowchartCompactPreviewNodeProps): ReactElement {
    return (
      <div data-el={dataEl(dataElScope, 'FlowchartCompactPreviewNode/Entry')} style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: PREVIEW_NODE_GAP,
        }}>
        <div style={{
            padding: '4px 10px',
            borderRadius: getPreviewNodeRadius({ isEnd, isStart }),
            backgroundColor: getPreviewNodeBackgroundColor(isStart),
            boxShadow: getPreviewNodeBoxShadow(isStart),
            fontFamily: getFontFamily(),
            fontSize: 10,
            color: getPreviewNodeTextColor(isStart),
            maxWidth: 180,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        }}>
          {label}
        </div>
        {hasConnector ? (<div style={{
                width: PREVIEW_CONNECTOR_WIDTH,
                height: PREVIEW_CONNECTOR_HEIGHT,
                backgroundColor: 'rgba(102,254,193,0.45)',
            }}/>) : null}
      </div>
    );
}
